import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { isEmpty: Boolean }

  initialize() {
    console.log("Datatable Controller - Initialize")
  }

  connect() {
    this.dataTableId = $(this.element).find('table').attr('id')
    console.log(`Datatable Controller - Connect - dataTableId: ${this.dataTableId}, isEmpty: ${this.isEmptyValue}`)
    if (!this.isEmptyValue) {
      this.dataTable = $(this.element).find('table').DataTable({
        "searching": false,
        "lengthChange": false,
        "autoWidth": true,
        "pageLength": 25,
        "bDestroy": true
      })
    }
  }

  disconnect() {
    console.log(`Datatable Controller - Disconnect - ${this.dataTableId}`)
    if (this.dataTable) {
      this.dataTable.destroy()
    }
  }
}
